import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toastMessage } from "../../common/toast";
import "./style.css";

const AlertModal = ({
  openModal,
  HideModal,
  msg,
  isSubmitting,
  handleSubmit,
  title,
}) => {
  const user = useSelector((state) => state.root.user);

  return (
    <Modal
      size="lg"
      backdrop="static"
      show={openModal}
      onHide={HideModal}
      centered
      dialogClassName="alert-modal-dialog"
    >
      <button
        type="button"
        className="close custom-modal-close"
        onClick={HideModal}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="modal-body modal-body-flex">
        <div className="login-form" style={{ width: "100%" }}>
          <div className="formik-container2">
            <h4 className="margin3">{title}</h4>
            <div className="col-12 margin1">
              <p>{msg}</p>
            </div>
            <button
              className="savebutton"
              disabled={isSubmitting}
              onClick={handleSubmit}
            >
              {isSubmitting ? <Spinner animation="grow" size="sm" /> : "Yes"}
            </button>
            <button className="savebutton ml-2" onClick={HideModal}>
              No
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AlertModal;
